




















import { Component, Prop, Vue } from "vue-property-decorator";
import { IContractProduct } from "@/models/contracts";
import { ContractStatusCodes } from "@/models/contracts";
import { DataModules } from "@/store/modules/data";

@Component
export default class CProdStatusSummary extends Vue {
  // Props
  @Prop({ required: true })
  public product!: IContractProduct;

  @Prop({ default: true })
  public hasIcon!: boolean;

  // Computed

  public get status() {
    return this.$_.get(this.product, "status");
  }

  public get isSubscription() {
    return this.$store.getters[
      `data/${DataModules.CONTRACTS_PRODUCTS}/isSubscription`
    ](this.product);
  }

  public get hasAutoExpireEnabled() {
    return this.$store.getters[
      `data/${DataModules.CONTRACTS_PRODUCTS}/hasAutoExpireEnabled`
    ](this.product);
  }

  public get hasAutoRenewDisabled() {
    return this.$store.getters[
      `data/${DataModules.CONTRACTS_PRODUCTS}/hasAutoRenewDisabled`
    ](this.product);
  }

  public get otpSummary() {
    switch (this.$_.get(this.status, "code")) {
      case ContractStatusCodes.PENDING:
        return {
          path: "_.awaiting_payment",
          class: "has-text-warning",
          icon: "sync-alt"
        };
      case ContractStatusCodes.AWAITING_ACTIVATION:
        return {
          path: "_.awaiting_activation",
          class: "has-text-success",
          icon: "sync-alt"
        };
      case ContractStatusCodes.ACTIVE:
        return {
          path: "_.fulfilled",
          class: "has-text-success",
          icon: "check"
        };
      case ContractStatusCodes.CANCELLED:
        return {
          path: "_.cancelled",
          class: "has-text-grey",
          icon: "times"
        };
      case ContractStatusCodes.CLOSED:
        return {
          path: "_.lapsed",
          class: "has-text-grey",
          icon: "ban"
        };
      default:
        return {
          path: this.$_.get(this.status, "name")
        };
    }
  }

  public get subSummary() {
    switch (this.$_.get(this.status, "code")) {
      case ContractStatusCodes.PENDING:
        return {
          path: "_.subscription_pending_summary",
          date: this.product.next_due_date,
          formatFunction: "calendar",
          class: "has-text-warning",
          icon: "sync-alt"
        };
      case ContractStatusCodes.AWAITING_ACTIVATION:
        return {
          path: "_.subscription_awaiting_activation_summary",
          date: this.product.next_due_date,
          formatFunction: "calendar",
          class: "has-text-success",
          icon: "sync-alt"
        };
      case ContractStatusCodes.ACTIVE:
        if (this.hasAutoExpireEnabled)
          return {
            path: "_.subscription_active_expiring_summary",
            date: this.product.calculated_close_date,
            formatFunction: "calendar",
            class: "has-text-danger",
            icon: "exclamation-circle"
          };
        else if (this.hasAutoRenewDisabled)
          return {
            path: "_.subscription_active_manually_renew_summary",
            date: this.product.next_due_date,
            formatFunction: "calendar",
            class: "has-text-warning",
            icon: "exclamation-circle"
          };
        else
          return {
            path: "_.subscription_active_summary",
            date: this.product.next_due_date,
            formatFunction: "calendar",
            class: "has-text-success",
            icon: "check"
          };
      case ContractStatusCodes.SUSPENDED:
        return {
          path: "_.subscription_suspended_summary",
          date: this.product.next_due_date,
          formatFunction: "fromNow",
          formatFunctionParams: true,
          class: "has-text-danger",
          icon: "pause-circle"
        };
      case ContractStatusCodes.CANCELLED:
        return {
          path: "_.subscription_cancelled_summary",
          date: this.product.cancelled_date,
          formatFunction: "calendar",
          class: "has-text-dark",
          icon: "times"
        };
      case ContractStatusCodes.CLOSED:
        return {
          path: "_.subscription_closed_summary",
          date: this.product.calculated_close_date,
          formatFunction: "calendar",
          class: "has-text-grey",
          icon: "ban"
        };
      default:
        return {
          path: this.$_.get(this.status, "name")
        };
    }
  }

  public get summary() {
    if (this.isSubscription) {
      return this.subSummary;
    } else {
      return this.otpSummary;
    }
  }
}
